<template>
    <div class="content-wrapper">
        <b-row>
            <div class="col-lg-12 col-xl-4">
                <RegisterStatus
                    :project="project"
                    :user="authUserInfo"
                    :data="allatkey"
                    @get:allatkey="getAllatkey"
                ></RegisterStatus>
            </div>
            <div class="col-lg-12 col-xl-8">
                <b-overlay
                    :show="status === 'loading'"
                >
                    <TransactionHistory
                        :data="history"
                        :status="status"
                    ></TransactionHistory>
                </b-overlay>
            </div>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RegisterStatus from './_components/RegisterStatus'
import TransactionHistory from './_components/TransactionHistory'
export default {
    props: {
        project: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    components: {
        RegisterStatus,
        TransactionHistory
    },
    computed: {
        ...mapGetters({
            history: '$_register_card/regularBillingHistory',
            allatkey: '$_register_card/regularBillingAllatkey',
            status: '$_register_card/status',
            authUserInfo: 'authUserInfo'
        })
    },
    methods: {
        ...mapActions({
            getRegularBillingHistory: '$_register_card/getRegularBillingHistory',
            getRegularBillingAllatkey: '$_register_card/getRegularBillingAllatkey'
        }),
        getAllatkey () {
            this.getRegularBillingAllatkey({ usageAccountId: this.project.usageAccountId })
        }
    },
    watch: {
        project: {
            handler (value, oldValue) {
                if (!oldValue.projectIdx) return
                if (value.projectIdx === oldValue.projectIdx) return
                this.getRegularBillingAllatkey({ usageAccountId: value.usageAccountId })
                this.getRegularBillingHistory({ proejctIdx: value.project, usageAccountId: value.usageAccountId })
            }
        }
    }
}
</script>

<style>

</style>
